"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class NavigationSearchControl
         */
        var NavigationSearchControl = /** @class */ (function (_super) {
            __extends(NavigationSearchControl, _super);
            function NavigationSearchControl() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.click = function () {
                    if (!_this.SearchFieldVisible()) {
                        _this.SearchFieldVisible(true);
                        _this.recordTelemetry();
                        if (!_this.boundEventHandlers) {
                            $(document.body).on("resetShellOnNavigation.dynNavigationBarSearch", function () {
                                _this.SearchFieldVisible(false);
                                _this.closeResults();
                                if (_this.boundEventHandlers) {
                                    $(document.body).off(".dynNavigationBarSearch");
                                    _this.boundEventHandlers = false;
                                }
                            });
                            $(document.body).on("click.dynNavigationBarSearch", function (event) {
                                if (!$.contains(_this.element, event.target)) {
                                    _this.SearchFieldVisible(false);
                                    _this.closeResults();
                                    if (_this.boundEventHandlers) {
                                        $(document.body).off(".dynNavigationBarSearch");
                                        _this.boundEventHandlers = false;
                                    }
                                }
                            });
                            _this.boundEventHandlers = true;
                        }
                    }
                    if (document.activeElement !== _this.element.querySelector("input")) {
                        _this.inputBoxElement = _this.inputBoxElement || _this.element.querySelector("input");
                        setTimeout(function () {
                            _this.inputBoxElement.focus();
                            if (_this.inputBoxElement.value.length > 0) {
                                $dyn.ui.selectionStart(_this.inputBoxElement, 0);
                                $dyn.ui.selectionEnd(_this.inputBoxElement, _this.inputBoxElement.value.length);
                            }
                        }, 0);
                    }
                    else {
                        // close flyout
                        _this.closeResults();
                        if (!_this.SearchFieldAlwaysOpen()) {
                            _this.SearchFieldVisible(false);
                        }
                    }
                };
                return _this;
            }
            NavigationSearchControl.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                // Method that gets overridden in html-binding-telemetry
                this.recordTelemetry = function () { };
                this.SearchFieldVisible = $dyn.observable(false);
                this.SearchFieldNotVisible = $dyn.computed(function () { return !$dyn.value(_this.SearchFieldVisible); });
                this.SearchFieldAlwaysOpen = $dyn.observable(false);
            };
            NavigationSearchControl.prototype.dispose = function () {
                if (this.boundEventHandlers) {
                    $(document.body).off(".dynNavigationBarSearch");
                }
                _super.prototype.dispose.call(this);
            };
            NavigationSearchControl.prototype.closeResults = function () {
                this.searchBox = this.searchBox || $dyn.context(this.element.querySelector("[data-dyn-controlname='NavigationSearchBox']"));
                if (this.searchBox) {
                    this.searchBox.ShowResultPicker(false);
                }
            };
            return NavigationSearchControl;
        }($dyn.ui.Control));
        controls.NavigationSearchControl = NavigationSearchControl;
        $dyn.ui.addObservablePropertiesToPrototype(NavigationSearchControl.prototype, {
            CombinedSearchEnabled: $dyn.debug.combinedSearch
        });
        $dyn.adapter({ id: "NavigationSearchButton", controlType: "NavigationSearchControl", template: "NavigationSearchButton" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=NavigationSearchControl.js.map
